import React from 'react';
import { Card, CardContent } from '../../components/ui/card';
import { SCREENER_PRESETS } from './screenerConstants';

const PresetGrid = ({ activePreset, onPresetChange }) => (
  <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-8">
    {SCREENER_PRESETS.map((preset) => {
      const Icon = preset.icon;
      const active = activePreset === preset.id;
      return (
        <Card
          key={preset.id}
          className={`cursor-pointer transition-all hover:shadow-md ${
            active ? 'border-purple-500 bg-purple-50' : ''
          }`}
          onClick={() => onPresetChange(preset.id)}
          data-testid={`screener-preset-${preset.id}`}
        >
          <CardContent className="p-4 text-center">
            <div
              className={`w-10 h-10 mx-auto mb-2 rounded-full flex items-center justify-center ${
                active ? 'bg-purple-600 text-white' : 'bg-gray-100 text-gray-600'
              }`}
            >
              <Icon size={20} />
            </div>
            <p className="font-semibold text-sm text-gray-900">{preset.name}</p>
            <p className="text-xs text-gray-500">{preset.description}</p>
          </CardContent>
        </Card>
      );
    })}
  </div>
);

export default PresetGrid;
